import React from 'react'
import ReactDOM from 'react-dom'
import 'bootstrap/dist/css/bootstrap.min.css'
import App from './App'
import reportWebVitals from './reportWebVitals'
import DeviceCheck from './components/molecules/DeviceCheck'
// import AppTest from './AppTest'

ReactDOM.render(
  <DeviceCheck>
    <App />
  </DeviceCheck>

  , document.getElementById('root'))

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
